import {makeStyles} from "@material-ui/styles";
import * as React from "react";
import {useEffect, useState} from "react";

const useStyles = makeStyles({
    flag: {
        display: 'inline-block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        '&.size': {
            '&-s': {
                width: 16,
                height: 12,
                '&.drop-shadow': {
                    boxShadow: '0 0 1px 0.5px rgba(0,0,0,0.10)'
                },
                '&.border-radius': {
                    borderRadius: 1,
                    '&.border': {
                        '&::before': {
                            borderRadius: 1
                        }
                    }
                },
                '&.circular': {
                    display: 'flex',
                    justifyContent: 'center',
                    height: 12,
                    borderRadius: '50% !important',
                    '& svg': {
                        width: 'auto',
                        flexShrink: 0
                    }
                },
            },
            '&-m': {
                width: 20,
                height: 15,
                '&.drop-shadow': {
                    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.10)'
                },
                '&.border-radius': {
                    borderRadius: 1.5,
                    '&.border': {
                        '&::before': {
                            borderRadius: 1.5
                        }
                    }
                },
                '&.circular': {
                    display: 'flex',
                    justifyContent: 'center',
                    width: 15,
                    borderRadius: '50% !important',
                    '& svg': {
                        width: 'auto',
                        flexShrink: 0
                    }
                },
            },
            '&-l': {
                width: 32,
                height: 24,
                '&.drop-shadow': {
                    boxShadow: '0 2px 3px 0 rgba(0,0,0,0.10)'
                },
                '&.border-radius': {
                    borderRadius: 2,
                    '&.border': {
                        '&::before': {
                            borderRadius: 2
                        }
                    }
                },
                '&.circular': {
                    display: 'flex',
                    justifyContent: 'center',
                    width: 24,
                    borderRadius: '50% !important',
                    '& svg': {
                        width: 'auto',
                        flexShrink: 0
                    }
                },
            }
        },
        '&.border': {
            '&:before': {
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'block',
                mixBlendMode: 'overlay',
                boxSizing: 'border-box',
                border: '1px solid rgba(0, 0, 0, .5)'
            }
        },
        '&.top-down': {
            '&::before': {
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'block',
                mixBlendMode: 'overlay',
                boxSizing: 'border-box',
                backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,0.30) 2%, rgba(255,255,255,0.70) 100%)'
            }
        },
        '&.real-linear': {
            '&::before': {
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'block',
                mixBlendMode: 'overlay',
                boxSizing: 'border-box',
                backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,0.20) 0%, rgba(39,39,39,0.22) 11%, rgba(255,255,255,0.30) 27%, rgba(0,0,0,0.24) 41%, rgba(0,0,0,0.55) 52%, rgba(255,255,255,0.26) 63%, rgba(0,0,0,0.27) 74%, rgba(255,255,255,0.30) 100%)'
            }
        },
        '&.real-circular': {
            '&::before': {
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'block',
                mixBlendMode: 'overlay',
                boxSizing: 'border-box',
                background: 'radial-gradient(50% 36%, rgba(255,255,255,0.30) 0%, rgba(0,0,0,0.24) 11%, rgba(0,0,0,0.55) 17%, rgba(255,255,255,0.26) 22%, rgba(0,0,0,0.17) 27%, rgba(255,255,255,0.28) 31%, rgba(255,255,255,0.00) 37%) center calc(50% - 8px) / 600% 600%,radial-gradient(50% 123%, rgba(255,255,255,0.30) 25%, rgba(0,0,0,0.24) 48%, rgba(0,0,0,0.55) 61%, rgba(255,255,255,0.26) 72%, rgba(0,0,0,0.17) 80%, rgba(255,255,255,0.28) 88%, rgba(255,255,255,0.30) 100%) center calc(50% - 8px) / 600% 600%'
            }
        },
        '& svg': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }
}, {name: "Flag"});

export default function Flag({
    code = 'SE',
    size = 'l',
    gradient = '',
    hasBorder = true,
    hasDropShadow = false,
    hasBorderRadius = true,
    circular = false,
    className
}) {
    const classes = useStyles();

    return (
        <div
            className={[classes.flag, `${gradient} size-${size} ${hasBorder ? 'border' : ''} ${hasDropShadow ? 'drop-shadow' : ''} ${hasBorderRadius ? 'border-radius' : ''} ${circular ? 'circular' : ''} ${className ? className.replace(/\s\s+/g, ' ').trim() : ''}`].join(' ')}>
            <img alt={code} src={`/images/flags/${size}/${code}.svg`}/>
        </div>
    );
}
